"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.math.hypot.js");
require("core-js/modules/web.timers.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Modal = _interopRequireDefault(require("../Modal"));
var _utils = require("../_utils");
var _excluded = ["previewSrc", "className", "visible"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ImageViewer = function ImageViewer(props) {
  var _touchData$scale3, _touchData$scale4;
  var previewSrc = props.previewSrc,
    className = props.className,
    visible = props.visible,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('img-preview');
  var classes = (0, _classnames.default)("".concat(prefixCls, "__viewer"), className);

  // 是否移动端
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  // 是否添加 transition
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    disableTransition = _useState4[0],
    setDisableTransition = _useState4[1];
  // 是否添加 translate
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isTranslate = _useState6[0],
    setIsTranslate = _useState6[1];

  // 预览图片ref
  var imageEl = (0, _react.useRef)(null);
  // 图片初始宽度
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    initImageSize = _useState8[0],
    setInitImageSize = _useState8[1];
  // 缩放数据
  var _useState9 = (0, _react.useState)({
      originScale: 1
    }),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    touchData = _useState10[0],
    setTouchData = _useState10[1];
  // 最大缩放
  var MINSCALE = 1;
  var MAXSCALE = 3;

  // 判断当前设备是否是手机端，并且屏幕尺寸是否小于 769
  var isMobileFunc = function isMobileFunc() {
    var result = (0, _utils.isMobile)(window.navigator.userAgent) && window.innerWidth < 769;
    setIsMobile(result);
  };

  // 获取两个坐标距离
  var getDistance = function getDistance(start, stop) {
    return Math.hypot(stop.x - start.x, stop.y - start.y);
  };

  // 触摸手指的初始位置
  var initTouchPosition = (0, _react.useRef)({
    x: 0,
    y: 0
  });
  // 图片最终的 translate 位置
  var _useState11 = (0, _react.useState)(null),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    finalImagePosition = _useState12[0],
    setFinalImagePosition = _useState12[1];

  // 添加触摸屏事件
  var handleTouchStart = function handleTouchStart(e) {
    if (!initImageSize) return;
    var temTouchData = {};
    var touches = e.touches;
    var touchEvent1 = touches[0];
    var touchEvent2 = touches[1];

    // 初始位置赋值
    initTouchPosition.current = {
      x: (touchEvent1 === null || touchEvent1 === void 0 ? void 0 : touchEvent1.pageX) || 0,
      y: (touchEvent1 === null || touchEvent1 === void 0 ? void 0 : touchEvent1.pageY) || 0
    };

    // 触摸数据
    temTouchData = _objectSpread(_objectSpread({}, temTouchData), {}, {
      pageX1: touchEvent1 === null || touchEvent1 === void 0 ? void 0 : touchEvent1.pageX,
      // 第一个触摸点的 X 坐标
      pageY1: touchEvent1 === null || touchEvent1 === void 0 ? void 0 : touchEvent1.pageY,
      // 第一个触摸点的 Y 坐标
      pageX2: touchEvent2 === null || touchEvent2 === void 0 ? void 0 : touchEvent2.pageX,
      // 第一个触摸点的 X 坐标
      pageY2: touchEvent2 === null || touchEvent2 === void 0 ? void 0 : touchEvent2.pageY,
      // 第一个触摸点的 Y 坐标
      moveable: true,
      // 可移动
      translateX: finalImagePosition ? finalImagePosition.x : -initImageSize.width / 2,
      // 当前图片的 translateX
      translateY: finalImagePosition ? finalImagePosition.y : -initImageSize.height / 2 // 当前图片的 translateY
    });
    setTouchData(_objectSpread(_objectSpread({}, touchData), temTouchData));
  };
  var handleTouchMove = function handleTouchMove(e) {
    if (!touchData.moveable || !initImageSize) return;
    var temTouchData = _objectSpread({}, touchData);
    var touches = e.touches;
    var touchEvent1 = touches[0];
    var touchEvent2 = touches[1];
    // 双指缩放比例计算
    var zoom = temTouchData.originScale;
    if (touchEvent2) {
      var _temTouchData$pageX, _temTouchData$pageY;
      // 双指移动 —— 缩放
      // 第2个指头坐标在touchmove时候获取
      temTouchData.pageX2 = (_temTouchData$pageX = temTouchData.pageX2) !== null && _temTouchData$pageX !== void 0 ? _temTouchData$pageX : touchEvent2.pageX;
      temTouchData.pageY2 = (_temTouchData$pageY = temTouchData.pageY2) !== null && _temTouchData$pageY !== void 0 ? _temTouchData$pageY : touchEvent2.pageY;

      // 双指缩放比例计算
      zoom = zoom * getDistance({
        x: touchEvent1.pageX,
        y: touchEvent1.pageY
      }, {
        x: touchEvent2.pageX,
        y: touchEvent2.pageY
      }) / getDistance({
        x: temTouchData.pageX1,
        y: temTouchData.pageY1
      }, {
        x: temTouchData.pageX2,
        y: temTouchData.pageY2
      });

      // 最大缩放比例限制
      if (zoom > MAXSCALE) {
        zoom = MAXSCALE;
      }
      if (zoom < MINSCALE) {
        zoom = MINSCALE;
      }

      // 更新缩放值
      setTouchData(_objectSpread(_objectSpread({}, touchData), {}, {
        scale: zoom,
        isDoubleTouch: true
      }));
      if (temTouchData.translateX !== undefined && temTouchData.translateY !== undefined) {
        // 保存当前图片最终的 translate 值
        // 最终 translate = 当前 translate + 图片缩放的尺寸差值 / 2
        setFinalImagePosition({
          x: temTouchData.translateX + (temTouchData.originScale - zoom) * initImageSize.width / 2,
          y: temTouchData.translateY + (temTouchData.originScale - zoom) * initImageSize.height / 2
        });
      }
    } else {
      if (touchData.isDoubleTouch) return;

      // 单指移动 —— 图片位移
      // 照片的初始位置 + 手指移动的坐标差
      var offsetX = touchEvent1.pageX - initTouchPosition.current.x;
      var offsetY = touchEvent1.pageY - initTouchPosition.current.y;
      if (temTouchData.translateX !== undefined && temTouchData.translateY !== undefined) {
        // 保存当前图片最终的 translate 值
        // 最终 translate = 当前 translate +  手指移动的坐标差
        setFinalImagePosition({
          x: temTouchData.translateX + offsetX,
          y: temTouchData.translateY + offsetY
        });
      }
    }
    // 实时更新 translate 值
    setIsTranslate(true);
    // 添加 transition
    setDisableTransition(true);
  };
  var handleTouchEnd = function handleTouchEnd() {
    var _touchData$scale;
    setTouchData(_objectSpread(_objectSpread({}, touchData), {}, {
      moveable: false,
      isDoubleTouch: false,
      pageX2: undefined,
      pageY2: undefined,
      originScale: (_touchData$scale = touchData.scale) !== null && _touchData$scale !== void 0 ? _touchData$scale : MINSCALE // 记录每次双指最后的缩放值
    }));
    setDisableTransition(false);
  };
  var handleTouchCancel = function handleTouchCancel() {
    var _touchData$scale2;
    setTouchData(_objectSpread(_objectSpread({}, touchData), {}, {
      moveable: false,
      isDoubleTouch: false,
      pageX2: undefined,
      pageY2: undefined,
      originScale: (_touchData$scale2 = touchData.scale) !== null && _touchData$scale2 !== void 0 ? _touchData$scale2 : MINSCALE // 记录每次双指最后的缩放值
    }));
    setDisableTransition(false);
  };

  // 双击事件（移动端无 doubleClick）
  var lastClickTime = (0, _react.useRef)(0);
  var clickTimer = (0, _react.useRef)();
  var handleClick = function handleClick() {
    if (!initImageSize) return;
    var nowTime = new Date().getTime();
    if (nowTime - lastClickTime.current < 400) {
      // 双击
      lastClickTime.current = 0;
      if (clickTimer.current) clearTimeout(clickTimer.current);

      // 执行缩放处理
      if (touchData.scale !== MAXSCALE) {
        // 如果缩放不是最大，则放大到最大：3
        setTouchData(_objectSpread(_objectSpread({}, touchData), {}, {
          scale: MAXSCALE,
          originScale: MAXSCALE
        }));
        if (touchData.translateX !== undefined && touchData.translateY !== undefined) {
          setFinalImagePosition({
            x: -(initImageSize.width * MAXSCALE) / 2,
            y: -(initImageSize.height * MAXSCALE) / 2
          });
        }
      } else {
        // 如果缩放已经是最大，则缩小到默认值
        setTouchData(_objectSpread(_objectSpread({}, touchData), {}, {
          scale: MINSCALE,
          originScale: MINSCALE
        }));
        if (touchData.translateX !== undefined && touchData.translateY !== undefined) {
          setFinalImagePosition({
            x: -(initImageSize.width * MINSCALE) / 2,
            y: -(initImageSize.height * MINSCALE) / 2
          });
        }
      }

      // 双击缩放时不添加 translate
      // 因为 translate + width + height + transition 会抖动
      setIsTranslate(false);
    } else {
      // 单击
      lastClickTime.current = nowTime;
      clickTimer.current = setTimeout(function () {
        // 执行单击操作
      }, 400);
    }
  };
  (0, _react.useEffect)(function () {
    isMobileFunc();
    window.addEventListener('resize', function () {
      return isMobileFunc();
    });
    return function () {
      window.addEventListener('resize', function () {
        return isMobileFunc();
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    // 获取 previewSrc 传入的图片地址的宽高
    // 宽：限制最大宽度不超过屏幕的 90%
    // 高：等比例缩放
    if (isMobile && visible && previewSrc) {
      var img = new Image();
      img.src = previewSrc;
      img.onload = function () {
        var zoom = img.height / img.width;
        var temW = Math.min(img.width, Math.floor(window.innerWidth * 0.9));
        var temH = temW * zoom;
        setInitImageSize({
          width: temW,
          height: temH
        });
      };
    }
    return function () {
      // 组件卸载重置
      setTouchData({
        originScale: MINSCALE
      });
      setIsTranslate(false);
      setInitImageSize(null);
      setFinalImagePosition(null);
    };
  }, [visible]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({
    className: classes,
    visible: visible
  }, extraProps, {
    maskClosable: true
  }), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, isMobile && initImageSize ? /*#__PURE__*/_react.default.createElement("img", {
    src: previewSrc,
    alt: "",
    ref: imageEl,
    onTouchStart: function onTouchStart(e) {
      return handleTouchStart(e);
    },
    onTouchMove: function onTouchMove(e) {
      return handleTouchMove(e);
    },
    onTouchEnd: function onTouchEnd() {
      return handleTouchEnd();
    },
    onTouchCancel: function onTouchCancel() {
      return handleTouchCancel();
    },
    onClick: function onClick() {
      return handleClick();
    },
    style: {
      // 宽度： 初始宽度 * 缩放比例
      width: "".concat(Math.floor(initImageSize.width * ((_touchData$scale3 = touchData.scale) !== null && _touchData$scale3 !== void 0 ? _touchData$scale3 : 1)), "px"),
      // 高度： 初始高度 * 缩放比例
      height: "".concat(Math.floor(initImageSize.height * ((_touchData$scale4 = touchData.scale) !== null && _touchData$scale4 !== void 0 ? _touchData$scale4 : 1)), "px"),
      transform: finalImagePosition && isTranslate ? "translate(".concat(Math.floor(finalImagePosition.x), "px, ").concat(Math.floor(finalImagePosition.y), "px)") : undefined,
      transition: disableTransition ? undefined : 'all 0.3s'
    }
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: previewSrc,
    alt: ""
  })));
};
var _default = exports.default = ImageViewer;